import React from "react";
import { glosses as glossesUnfilt } from "../Glosses";
import { XCircleIcon } from "@heroicons/react/solid";
import {
  MultiSelect,
  MultiSelectItem,
  Icon,
  List,
  ListItem,
} from "@tremor/react";
import { removeDiacriticsAndCapitalize } from "../../../utils/checkMisthosi";

const ChooseMetaf = ({ metafSelected, setMetafSelected }) => {
  const glosses = glossesUnfilt
    .map((dim) => removeDiacriticsAndCapitalize(dim))
    .sort();
  const handleDeleteListItem = (e) => {
    const value =
      e.target.parentNode.parentNode.parentNode.firstChild.textContent;
    const newMetafSelected = metafSelected.filter((dim) => dim !== value);
    setMetafSelected(newMetafSelected);
  };

  return (
    <div className="form-group">
      <label htmlFor="metaf">Μεταφράσεις:</label>
      <MultiSelect
        placeholder="Επιλέξτε Γλώσσα"
        onValueChange={setMetafSelected}
        value={metafSelected}
      >
        {glosses.map((dim, i) => {
          return (
            <MultiSelectItem key={`${i}-${dim}`} value={dim}>
              {dim}
            </MultiSelectItem>
          );
        })}
      </MultiSelect>
      <List>
        {metafSelected?.map((dim, i) => {
          return (
            <ListItem className="dimoi-list" key={`${i}-${dim}`}>
              <span>{dim}</span>
              <span>
                <Icon
                  onClick={handleDeleteListItem}
                  className={"cursor-pointer"}
                  icon={XCircleIcon}
                  size={"sm"}
                  color="red"
                  tooltip="Διαγραφή"
                ></Icon>
              </span>
              <ListItem />
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default ChooseMetaf;
